module.exports = __webpack_public_path__ + "img/image159.5fc068e1.jpg";